import { render, staticRenderFns } from "./StatsWorstPerformers.vue?vue&type=template&id=7ec598e8&"
import script from "./StatsWorstPerformers.vue?vue&type=script&lang=js&"
export * from "./StatsWorstPerformers.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports